export const UserConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    LOGIN_CAPTCHA: 'USERS_LOGIN_CAPTCHA',

    LOGOUT: 'USERS_LOGOUT',

    SITE_SETTINGS_SUCCESS: "SITE_SETTINGS_SUCCESS",
    SITE_SETTINGS_ERROR: "SITE_SETTINGS_ERROR",

    GET_CREATED_BY_SUCCESS: 'GET_CREATED_BY_SUCCESS',
    GET_CREATED_BY_FAILURE: 'GET_CREATED_BY_ERROR'
};